<template>
  <v-form ref="updateForm" lazy-validation>
    <loading-block class="pt-8" v-if="!loaded"></loading-block>
    <div v-else>
      <v-row class="pa-5">
        <v-col>
          <v-row>
            <v-col col="12" xl="9" lg="9" md="9">
              <v-autocomplete
                v-model="form.brand_id"
                :items="selectableBrands"
                label="Brand name"
              ></v-autocomplete>
            </v-col>
            <v-col col="12" xl="3" lg="3" md="3" class="mr-0 pr-0">
              <div class="my-0">
                <v-btn x-large color="primary" dark @click="enableAddModal()">
                  Create A Brand +
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-autocomplete
            v-model="form.category_id"
            :items="selectableCategories"
            label="Category"
          ></v-autocomplete>
          <v-text-field
            v-model="form.name"
            :rules="textValidation"
            name="Name"
            label="Name"
            required
            validate-on-blur
            type="text"
          ></v-text-field>
          <v-text-field
                v-model="form.sku"
                :rules="normalValidation"
                name="Sku"
                label="Sku"
                required
                validate-on-blur
                type="text"
          ></v-text-field>
          <v-text-field
                v-model="form.gtin"
                :rules="normalValidation"
                name="Gtin"
                label="Gtin"
                required
                validate-on-blur
                type="text"
          ></v-text-field>
          <v-text-field
                v-model="form.size"
                :rules="normalValidation"
                name="Size"
                label="Size"
                required
                validate-on-blur
                type="text"
          ></v-text-field>
          <v-text-field
                v-model="form.weight_equivalent_dry_cannabis"
                :rules="decimalValidation"
                name="Weight equivalent dry cannabis"
                label="Weight equivalent dry cannabis"
                required
                validate-on-blur
                type="text"
          ></v-text-field>
          <v-text-field
                v-model="form.no_of_units"
                :rules="positiveNumberValidation"
                name="No. of Units"
                label="No. of Units"
                required
                validate-on-blur
                type="text"
          ></v-text-field>
          <v-textarea
            v-model="form.description"
            name="Description"
            label="Description"
            required
            auto-grow
            rows="2"
            validate-on-blur
          ></v-textarea>
          <v-select
            v-model="form.product_family"
            :rules="normalValidation"
            :items="[
              {
                text: 'Cannabis',
                value: 'cannabis'
              },
              {
                text: 'Accessories',
                value: 'accessories'
              },
              {
                text: 'Liquor',
                value: 'liquor'
              },
              {
                text: 'Retail',
                value: 'retail'
              }
            ]"
            name="Product family"
            label="Product family"
          ></v-select>
          <v-select
            v-model="form.weighing_unit"
            :rules="normalValidation"
            :items="[
              'g',
              'ml',
              'kg',
              'ltr',
              'caps',
              'ea',
              'pack',
              'oz',
              'capsule',
              'bottle',
              'strips',
              'strip'
            ]"
            name="Weighing unit"
            label="Weighing unit"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="9" md="9"></v-col>
        <v-col sm="3" md="3" class="text-right">
          <v-btn
            @click="updateData()"
            slot="activator"
            small
            dark
            color="primary"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
          >
            Save Changes
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <New />
  </v-form>
</template>
<script>
import { ProductAPI } from '@/clients/product/product.api'
import { BrandAPI } from '@/clients/product/brand.api'
import { CategoryAPI } from '@/clients/product/category.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import Helper from '@/utility/Helpers'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import New from '../../Brand/New.vue'
export default {
  components: {
    LoadingBlock,
    New
  },
  data() {
    return {
      loaded: false,
      normalValidation: [v => !!v || 'Field is required'],
      textValidation: [
        v => !!v || 'Field is required',
        v => Helper.validateSpace(v) || `Blank value.`
      ],
      positiveNumberValidation: [
        v => !!v || 'Field is required',
        v => /^\+?([0-9]\d*)$/.test(v) || 'Positive numbers only'
      ],
      decimalValidation: [
        (v) => !!v || 'Field is required',
        v => v >= 0 || 'Positive numbers only',
        (v) => /^\d+(\.\d{1,2})?$/.test(v) || 'Field must be numeric'
      ],
      form: {
        brand_id: '',
        category_id: '',
        name: '',
        sku: '',
        description: '',
        weighing_unit: '',
        product_family: '',
        gtin: '',
        size: '',
        weight_equivalent_dry_cannabis: null,
        no_of_units: null
      },

      brandList: [],
      categoryList: []
    }
  },
  watch: {
    addModal(value) {
      if (value === false) {
        this.getBrandList()
      }
    }
  },
  computed: {
    selectableBrands: function() {
      return Helper.getSelectableValue(this.brandList, 'name', 'id')
    },
    selectableCategories: function() {
      return Helper.getSelectableValue(this.categoryList, 'name', 'id')
    },
    ...mapGetters({
      activeItem: 'product/activeItem',
      addModal: 'brand/addPop'
    })
  },
  async mounted() {
    this.spinner(false)
    this.loaded = false

    // brand list
    const brandData = await BrandAPI.brandList()
    this.brandList = _.sortBy(brandData.data.payload, 'name')
    // category list
    const CategoryData = await CategoryAPI.list()
    this.categoryList = _.sortBy(CategoryData.data.payload, 'name')

    if (!_.isEmpty(this.activeItem)) {
      for (let key in this.form) {
        this.form[key] = this.activeItem[key]
      }
    } else {
      Helper.setObjValueEmpty(this.form)
    }
    // bus.$on('updated-featured-discontinue-switch', (payload) => {
    //   for (let key in this.form) {
    //     this.form[key] = payload[key]
    //   }
    // })

    this.loaded = true
  },
  methods: {
    /**
     * Update
     */
    async updateData() {
      if (this.$refs['updateForm'].validate()) {
        try {
          // Trigger apis
          this.spinner(true)
          let res = await ProductAPI.edit(this.activeItem.id, this.form)
          this.spinner(false)
          if (res.status === 200) {
            this.setActiveItem({
              ...res.data.payload,
              discontinued: this.activeItem.discontinued,
              featured: this.activeItem.featured
            })
          }
          // Display message alert
          this.snackbar({
            text:
              res.status === 200
                ? res.data.msg
                : res.response.data.errors
                ? res.response.data.errors[0]
                : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors
              ? err.response.data.errors[0]
              : err.response.data.msg,
            open: true,
            color: 'error'
          })
        }
      }
    },

    /**
     * Add Brand
     */
    enableAddModal() {
      this.setAddPop(true)
    },

    /**
     * Fetch Brand List
     */
    async getBrandList() {
      try {
        const {
          data: { payload }
        } = await BrandAPI.brandList()
        this.brandList = _.sortBy(payload, 'name')
      } catch (err) {
        this.brandList = []
      }
    },

    ...mapActions({
      setActiveItem: 'product/setActiveItem',
      setAddPop: 'brand/setAddPop'
    })
  }
}
</script>
